import _ from "underscore";
import templateUrl from 'emun.order/terms/terms-list.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import TermsPrompt from "emun.order/terms/terms-prompt";
import ServiceBus from "servicestack/service-bus";
import modals from 'webmodals/modals';

class TermsListController {
    constructor($rootScope) { 
        let $ctrl = this;
        basicController($ctrl);
		$ctrl.bus = new ServiceBus();
    }
	$onInit() {
		const $ctrl = this;
		$ctrl.query = new AutoQuery({
			url: 'QueryPaymentTerms.json',
			autoLoad: true,
			onLoaded: function (args) {
				args.results.forEach(function (obj) {
					obj.originalPaymentTerm = obj.id;
				});
			},
            pageSize: 12,
            scrollTop: false
		});
	}
	edit(term) {
		const $ctrl = this;
		TermsPrompt.open({ request: term }).then(() => $ctrl.query.load());
	}
	create() {
		const $ctrl = this;
		TermsPrompt.open({}).then(() => $ctrl.query.load());
	}
	delete(term) {
		const $ctrl = this;
		return modals.confirm("Are you sure you want to delete term " + term.name + "?", "Delete Term").result.then(function () {
			$ctrl.bus.send('DeletePaymentTerm.json', term).then(function (response) {
				$ctrl.query.load();
			});
		});
	}
}

let TermsList = {
    bindings: {
    },
    controller: TermsListController,
    templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
    }
}

export default TermsList;